var taxonomyItems = {
    categories: [
        {
            title: 'AI Apps and Agents',
            icon: 'AIAgents',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'ai-apps-and-agents'
                }
            }
        },
        {
            title: 'Compliance & Legal',
            icon: 'Compare',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'compliance-legals'
                }
            }
        },
        {
            title: 'Human Resources',
            icon: 'PeopleAdd',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'human-resources'
                }
            }
        },
        {
            title: 'Operations & Supply Chain',
            icon: 'WorkFlow',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'operations'
                }
            }
        },
        {
            title: 'Analytics',
            icon: 'analyticsview',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'analytics'
                }
            }
        },
        {
            title: 'Customer Service',
            icon: 'Telemarketer',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'customer-service'
                }
            }
        },
        {
            title: 'Internet of Things',
            icon: 'SplitObject',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'internet-of-things'
                }
            }
        },
        {
            title: 'Productivity',
            icon: 'SpeedHigh',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'productivity'
                }
            }
        },
        {
            title: 'Collaboration',
            icon: 'Transition',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'collaboration'
                }
            }
        },
        {
            title: 'Finance',
            icon: 'Money',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'finance'
                }
            }
        },
        {
            title: 'IT & Management Tools',
            icon: 'SecurityGroup',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'management-tools'
                }
            }
        },
        {
            title: 'Project Management',
            icon: 'Assign',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'project-management'
                }
            }
        },
        {
            title: 'Commerce',
            icon: 'ShoppingCart',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'commerce'
                }
            }
        },
        {
            title: 'Geolocation',
            icon: 'LocationOutline',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'geolocation'
                }
            }
        },
        {
            title: 'Marketing',
            icon: 'Megaphone',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'marketing'
                }
            }
        }
    ],
    industries: [
        {
            title: 'Defense & Intelligence',
            icon: 'Shield',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'defense-and-intelligence'
                }
            }
        },
        {
            title: 'Distribution',
            icon: 'DistributeDown',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'distribution'
                }
            }
        },
        {
            title: 'Education',
            icon: 'Education',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'education'
                }
            }
        },
        {
            title: 'Energy & Resources',
            icon: 'Lightbulb',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'energy'
                }
            }
        },
        {
            title: 'Financial Services',
            icon: 'Financial',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'financial-services'
                }
            }
        },
        {
            title: 'Government',
            icon: 'Flag',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'government'
                }
            }
        },
        {
            title: 'Healthcare',
            icon: 'Health',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'healthcare'
                }
            }
        },
        {
            title: 'Hospitality & Travel',
            icon: 'Airplane',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'hospitality-and-travel'
                }
            }
        },
        {
            title: 'Manufacturing & Mobility',
            icon: 'Manufacturing',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'manufacturing-resources'
                }
            }
        },
        {
            title: 'Nonprofit',
            icon: 'Heart',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'nonprofit'
                }
            }
        },
        {
            title: 'Professional Services',
            icon: 'Suitcase',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'professional-services'
                }
            }
        },
        {
            title: 'Retail & Consumer Goods',
            icon: 'BusinessHoursSign',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'retail-and-consumer-goods'
                }
            }
        },
        {
            title: 'Sustainability',
            icon: 'Cotton',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'sustainability'
                }
            }
        },
        {
            title: 'Telecommunications & Media',
            icon: 'Media',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'media-communications'
                }
            }
        }
    ]
};
var unifiedTaxonomyItems = {
    categories: [
        {
            title: 'AI Apps and Agents',
            icon: 'AIAgents',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'ai-apps-and-agents'
                }
            }
        },
        {
            title: 'Analytics',
            icon: 'analyticsview',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'analytics'
                }
            }
        },
        {
            title: 'Blockchain',
            icon: 'Blockchain',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'blockchain'
                }
            }
        },
        {
            title: 'Collaboration',
            icon: 'Transition',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'collaboration'
                }
            }
        },
        {
            title: 'Commerce',
            icon: 'ShoppingCart',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'commerce'
                }
            }
        },
        {
            title: 'Compliance & Legal',
            icon: 'Compare',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'compliance-legals'
                }
            }
        },
        {
            title: 'Customer Service',
            icon: 'Telemarketer',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'customer-service'
                }
            }
        },
        {
            title: 'Databases',
            icon: 'Database',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'databases'
                }
            }
        },
        {
            title: 'Developer Tools',
            icon: 'DeveloperTool',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'developer-tools'
                }
            }
        },
        {
            title: 'DevOps',
            icon: 'Devops',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'devops'
                }
            }
        },
        {
            title: 'Finance',
            icon: 'Money',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'finance'
                }
            }
        },
        {
            title: 'Geolocation',
            icon: 'LocationOutline',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'geolocation'
                }
            }
        },
        {
            title: 'Human Resources',
            icon: 'PeopleAdd',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'human-resources'
                }
            }
        },
        {
            title: 'Identity',
            icon: 'Identity',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'identity'
                }
            }
        },
        {
            title: 'Infrastructure Services',
            icon: 'Compute',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'infrastructure-services'
                }
            }
        },
        {
            title: 'Integration',
            icon: 'Integration',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'integration'
                }
            }
        },
        {
            title: 'Internet of Things',
            icon: 'SplitObject',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'internet-of-things'
                }
            }
        },
        {
            title: 'IT & Management Tools',
            icon: 'SecurityGroup',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'management-tools'
                }
            }
        },
        {
            title: 'Machine Learning',
            icon: 'CategoryAIMachineLearning',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'ai-plus-machine-learning'
                }
            }
        },
        {
            title: 'Marketing',
            icon: 'Megaphone',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'marketing'
                }
            }
        },
        {
            title: 'Media',
            icon: 'Media',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'media'
                }
            }
        },
        {
            title: 'Microsoft Entra ID',
            icon: 'MicrosoftEntraId',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'microsoft-entra-id'
                }
            }
        },
        {
            title: 'Migration',
            icon: 'Migration',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'migration'
                }
            }
        },
        {
            title: 'Mixed Reality',
            icon: 'MixReality',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'mixed-reality'
                }
            }
        },
        {
            title: 'Monitoring & Diagnostics',
            icon: 'MonitoringAndDiagnostics',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'monitoring-and-diagnostics'
                }
            }
        },
        {
            title: 'Operations & Supply Chain',
            icon: 'WorkFlow',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'operations'
                }
            }
        },
        {
            title: 'Productivity',
            icon: 'SpeedHigh',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'productivity'
                }
            }
        },
        {
            title: 'Project Management',
            icon: 'Assign',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'project-management'
                }
            }
        },
        {
            title: 'Sales',
            icon: 'Shop',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'sales'
                }
            }
        },
        {
            title: 'Security',
            icon: 'Security',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'security'
                }
            }
        },
        {
            title: 'Web',
            icon: 'Globe',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'web'
                }
            }
        }
    ],
    industries: [
        {
            title: 'Defense & Intelligence',
            icon: 'Shield',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'defense-and-intelligence'
                }
            }
        },
        {
            title: 'Distribution',
            icon: 'DistributeDown',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'distribution'
                }
            }
        },
        {
            title: 'Education',
            icon: 'Education',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'education'
                }
            }
        },
        {
            title: 'Energy & Resources',
            icon: 'Lightbulb',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'energy'
                }
            }
        },
        {
            title: 'Financial Services',
            icon: 'Financial',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'financial-services'
                }
            }
        },
        {
            title: 'Government',
            icon: 'Flag',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'government'
                }
            }
        },
        {
            title: 'Healthcare',
            icon: 'Health',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'healthcare'
                }
            }
        },
        {
            title: 'Hospitality & Travel',
            icon: 'Airplane',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'hospitality-and-travel'
                }
            }
        },
        {
            title: 'Manufacturing & Mobility',
            icon: 'Manufacturing',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'manufacturing-resources'
                }
            }
        },
        {
            title: 'Nonprofit',
            icon: 'Heart',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'nonprofit'
                }
            }
        },
        {
            title: 'Professional Services',
            icon: 'Suitcase',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'professional-services'
                }
            }
        },
        {
            title: 'Retail & Consumer Goods',
            icon: 'BusinessHoursSign',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'retail-and-consumer-goods'
                }
            }
        },
        {
            title: 'Sustainability',
            icon: 'Cotton',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'sustainability'
                }
            }
        },
        {
            title: 'Telecommunications & Media',
            icon: 'Media',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'media-communications'
                }
            }
        }
    ]
};

export { taxonomyItems, unifiedTaxonomyItems };
